import { service } from '../../../helpers/http'
export * from '../branch/store/actions'
export * from '../event/store/actions'
export * from '../company/store/actions'
export * from '../type_setting/store/actions'
export * from '../extract/store/actions'

export const ActionFindPaymentExports = ({ dispatch }, payload) => {

    // VueResource treats the 2nd argument of GET as body; send pagination/filters as query params.
    return service({
        module: 'paymentExport',
        action: 'find',
        params: payload,
        payload: {}
    })
}

export const ActionCreatePaymentExport = ({ dispatch }, payload) => {
    return service({
        module: 'paymentExport',
        action: 'create',
        payload: payload
    })
}

export const ActionUpdatePaymentExport = ({ dispatch }, payload) => {
    return service({
        module: 'paymentExport',
        action: 'update',
        payload: payload
    })
}

export const ActionDeletePaymentExport = ({ dispatch }, payload) => {
    return service({
        module: 'paymentExport',
        action: 'delete',
        payload: payload
    })
}

export const ActionFindValueTypes = ({ dispatch }, payload) => {

    return service({
        module: 'budget',
        action: 'valueTypes',
        payload: payload
    })
    
}

export const ActionFindPaymentExportStatus = ({ dispatch }, payload) => {

    return service({
        module: 'paymentExport',
        action: 'status',
        payload: payload
    })
    
}

export const ActionFindPaymentExportType = ({ dispatch }, payload) => {

    return service({
        module: 'paymentExport',
        action: 'type',
        payload: payload
    })
    
}

export const ActionGeneratePaymentExport = ({ dispatch }, payload) => {

    return service({
        module: 'paymentExport',
        action: 'generate',
        payload: payload
    })
    
}

export const ActionFindPaymentPeriodicityTypes = ({ dispatch }, payload) => {

    return service({
        module: 'paymentExport',
        action: 'periodicityTypes',
        payload: payload
    })
    
}

export const ActionFindPaymentExportItems = ({ dispatch }, payload) => {
    return service({
        module: 'paymentExport',
        action: 'findItems',
        payload: payload
    })
}

export const ActionFindPaymentExportItem = ({ dispatch }, payload) => {

    const { id, ...query } = payload || {}

    // VueResource treats the 2nd argument of GET as body; send params as query params.
    return service({
        module: 'paymentExport',
        action: 'findItem',
        params: { id, ...query },
        payload: {}
    })

}

export const ActionCreatePaymentExportItem = ({ dispatch }, payload) => {
    return service({
        module: 'paymentExport',
        action: 'createItem',
        payload: payload
    })
}

export const ActionUpdatePaymentExportItem = ({ dispatch }, payload) => {
    return service({
        module: 'paymentExport',
        action: 'updateItem',
        payload: payload
    })
}

export const ActionDeletePaymentExportItem = ({ dispatch }, payload) => {
    return service({
        module: 'paymentExport',
        action: 'deleteItem',
        payload: payload
    })
}

export const ActionIndexPaymentExportProratedTypes = ({ dispatch }, payload) => {

    return service({
        module: 'paymentExport',
        action: 'indexProratedTypes',
        payload: payload
    })
    
}

export const ActionIntegratePaymentExportTotvsRm = ({ dispatch }, payload) => {

    return service({
        module: 'paymentExport',
        action: 'integrateTotvsRm',
        payload: payload
    })

}

export const ActionIntegratePaymentExportsTotvsRmBatch = ({ dispatch }, payload) => {

    return service({
        module: 'paymentExport',
        action: 'integrateTotvsRmBatch',
        payload: payload
    })

}

export const ActionFindPaymentExportTotvsRmFailedItems = ({ dispatch }, payload) => {

    const { id, ...query } = payload || {}

    // VueResource treats the 2nd argument of GET as body; send pagination as query params.
    return service({
        module: 'paymentExport',
        action: 'integrateTotvsRmFailedItems',
        params: { id, ...query },
        payload: {}
    })

}

export const ActionFindPaymentExportTotvsRmMissingLinkItems = ({ dispatch }, payload) => {

    const { id, ...query } = payload || {}

    // VueResource treats the 2nd argument of GET as body; send pagination as query params.
    return service({
        module: 'paymentExport',
        action: 'integrateTotvsRmMissingLinkItems',
        params: { id, ...query },
        payload: {}
    })

}

export const ActionFindPaymentExportTotvsRmToSendItems = ({ dispatch }, payload) => {

    const { id, ...query } = payload || {}

    // VueResource treats the 2nd argument of GET as body; send pagination as query params.
    return service({
        module: 'paymentExport',
        action: 'integrateTotvsRmToSendItems',
        params: { id, ...query },
        payload: {}
    })

}

export const ActionFindPaymentExportTotvsRmIntegratedItems = ({ dispatch }, payload) => {

    const { id, ...query } = payload || {}

    // VueResource treats the 2nd argument of GET as body; send pagination as query params.
    return service({
        module: 'paymentExport',
        action: 'integrateTotvsRmIntegratedItems',
        params: { id, ...query },
        payload: {}
    })

}

export const ActionFindPaymentExportTotvsRmScopes = ({ dispatch }, payload) => {

    const { id } = payload || {}

    return service({
        module: 'paymentExport',
        action: 'integrateTotvsRmScopes',
        params: { id },
        payload: {}
    })

}

export const ActionReleasePaymentExportTotvsRmScope = ({ dispatch }, payload) => {

    return service({
        module: 'paymentExport',
        action: 'integrateTotvsRmScopeRelease',
        payload: payload
    })

}

export const ActionRollbackPaymentExportItemToLastIntegrated = ({ dispatch }, payload) => {

    return service({
        module: 'paymentExport',
        action: 'rollbackItemToLastIntegrated',
        payload: payload
    })

}

export const ActionRollbackPaymentExportGroupToLastIntegrated = ({ dispatch }, payload) => {

    return service({
        module: 'paymentExport',
        action: 'rollbackGroupToLastIntegrated',
        payload: payload
    })

}

export const ActionFindPaymentExportIndicators = ({ dispatch }, payload) => {
    // VueResource treats the 2nd argument of GET as body; send filters as query params.
    return service({
        module: 'paymentExport',
        action: 'indicators',
        params: payload,
        payload: {}
    })
}

export const ActionFindPaymentExportIndicatorItems = ({ dispatch }, payload) => {
    const { indicator, ...query } = payload || {}

    // VueResource treats the 2nd argument of GET as body; send pagination as query params.
    return service({
        module: 'paymentExport',
        action: 'indicatorItems',
        params: { indicator, ...query },
        payload: {}
    })
}

export const ActionRefreshTeacherMissingRegistrationContract = ({ dispatch }, payload) => {
    return service({
        module: 'paymentExport',
        action: 'refreshTeacherContract',
        payload: payload
    })
}
